import { useTranslation } from 'react-i18next';

import { Stack } from '@mui/material';

import { i18nNS } from '../../../../../i18n';
import DeletePoll from '../DeletePoll';
import EditPublishPreferences from '../EditPublishPreferences';
import PublishPoll, { PublishPollProps } from '../PublishPoll';
import StopPoll from '../StopPoll';
import usePollActions from './vm';
import ReusePoll from '../ReusePoll';

export interface PollActionsProps extends PublishPollProps {}

const PollActions = ({ triggerValidations, errors }: PollActionsProps) => {
  const { t } = useTranslation([i18nNS.GLOSSARY]);

  const { isPollPublished, isPresenting, isClassClosed } = usePollActions();

  if (isPollPublished) {
    return (
      <Stack direction="row" alignItems="center">
        <StopPoll />
        <ReusePoll />
      </Stack>
    );
  }

  if (isPresenting) {
    return (
      <Stack direction="row" alignItems="center">
        <PublishPoll
          triggerValidations={triggerValidations}
          label={t('publish', { ns: i18nNS.GLOSSARY })}
          errors={errors}
          isClassClosed={isClassClosed}
        />
      </Stack>
    );
  }

  return (
    <Stack direction="row" alignItems="center">
      <DeletePoll />
      <ReusePoll />
      <EditPublishPreferences isClassClosed={isClassClosed} />
      <PublishPoll triggerValidations={triggerValidations} isClassClosed={isClassClosed} errors={undefined} />
    </Stack>
  );
};

export default PollActions;
